import { InputForm } from "../atoms/input"
import { ModalButton } from "../atoms/buttons"
import { ModalTitle, ModalBody, ModalFooter } from "../components/modal"
import { useState } from 'react';
import { Alert } from "../components/alert";

export const EditContactForm = ({contactDetails, saveContactInfo}) => {
    const [changedContactInfo, changeContactInfo] = useState({"email": contactDetails.email, "phone_number": contactDetails.phone_number,"first_name": contactDetails.first_name,"last_name": contactDetails.last_name})
    const [errorMessage, setErrorMessage] = useState(false)

    async function saveChanges() {
        var api_change_response = await saveContactInfo(changedContactInfo)
        console.log(api_change_response.reason)
        if (!api_change_response.changed) {
            setErrorMessage(api_change_response.reason)
        }
    }

    return (
        <>
            <ModalTitle title={"Contactgegevens aanpassen"}/>
            <ModalBody content={<>
                { errorMessage && <> <Alert type="error" message={errorMessage} /><br/> </> }
                <InputForm title={"Voornaam"} typeInput={(newValue) => {changeContactInfo({...changedContactInfo, "first_name": newValue})}} placeholder={"John"} value={changedContactInfo.first_name}/>
                <InputForm title={"Achternaam"} typeInput={(newValue) => {changeContactInfo({...changedContactInfo, "last_name": newValue})}} placeholder={"Doe"} value={changedContactInfo.last_name}/>
                <InputForm title={"E-mail"} typeInput={(newValue) => {changeContactInfo({...changedContactInfo, "email": newValue})}} placeholder={"John@doe.com"} value={changedContactInfo.email} disabled={true}/>
                <Alert type="warning" message={"Vraag uw werkgever om uw e-mailadres te wijzigen."}  className={"phone-alert-email standard-small-margin-bottom"}/>
                <InputForm title={"Tel. nr"} typeInput={(newValue) => {changeContactInfo({...changedContactInfo, "phone_number": newValue})}} placeholder={"+31 6 12345678"} value={changedContactInfo.phone_number}/>
            </>}/>
            <ModalFooter content={<>
                <ModalButton title={"opslaan"} onClick={() => saveChanges()}/>
            </>}/>
        </>
    )
}